module.exports = __webpack_public_path__ + "img/aw.f5f0879b.svg";